module.exports = __webpack_public_path__ + "img/89e4e26e5a98ea7c342ea2ece8396ce1.0c60890c.png";